<template>
  <div class="pk-redesign-page">
    <Header class="pk-legacy-header"></Header>
    <header class="pk-redesign-header" v-if="gameState !== 'ended'">
      <button class="pk-redesign-back" type="button" :aria-label="$t('Back')" @click="$router.go(-1)">
        <img src="../../static/images/livequiz/back.png" alt="">
      </button>
    </header>
    <!-- 状态显示 -->
   <!-- <div class="status-bar">
      <div>连接状态：<span>{{ connectionStatus }}</span></div>
      <div>房间号：<span>{{ roomId || '-' }}</span></div>
      <div>我的等级：Lv.<span>{{ playerInfo.level || '-' }}</span></div>
    </div> -->

    <!-- 创建房间和加入房间按钮 -->
    <section class="pk-room-screen" v-if="showRoomControl && !showBuyMorePopup">
      <img class="pk-page-title" src="../../static/images/pk/team_mode_title.png" :alt="$t('game3T')">
      <div class="pk-room-panel">
        <img class="pk-room-panel-bg" src="../../static/images/ai_training/ai_training_bg.png" alt="">
        <div class="pk-room-panel-content">
          <p class="pk-room-description">{{$t('game3C')}}</p>
          <img class="pk-room-hero" src="../../static/images/pk/team_mode_photo.png" alt="">
          <div class="pk-room-matchup">
            <div class="pk-room-player">
              <img :src="info.avatar || '../../static/images/default-avatar.png'" alt="">
              <strong>{{info.nickname}}</strong>
            </div>
            <img class="pk-room-vs" src="../../static/images/pk/VS.png" alt="VS">
            <div class="pk-room-friend">
              <img src="../../static/images/pk/friend.png" alt="">
              <strong>{{$t('YourFriend')}}</strong>
            </div>
          </div>
          <div class="pk-room-join">
            <input v-model="roomInput" ref="getFocus2" maxlength="6" type="number" inputmode="numeric" :placeholder="$t('enterRoomID')">
            <button type="button" @click="joinRoom"><img src="../../static/images/pk/join_room_btn.png" alt=""><span>{{$t('JoinRoom')}}</span></button>
          </div>
          <button class="pk-room-create" type="button" @click="createRoom">{{$t('CreateRoom')}}</button>
        </div>
      </div>
    </section>

    <!-- 匹配等待 -->
    <section class="pk-matching-screen" v-if="gameState === 'matching' && !showBuyMorePopup">
      <img class="pk-page-title" src="../../static/images/pk/team_mode_title.png" :alt="$t('game3T')">
      <div class="pk-matching-panel">
        <img class="pk-matching-panel-bg" src="../../static/images/ai_training/ai_training_bg.png" alt="">
        <div class="pk-matching-panel-content">
          <h2>{{$t('WaitingTips')}}...</h2>
          <button v-if="room_id_div" id="copycode" class="pk-room-code" type="button" :data-clipboard-text="roomId" @click="copy(roomId)">
            <span>{{$t('RoomID')}}: {{ roomId || '-' }}</span>
            <img src="../../static/images/copy.png" alt="">
          </button>
          <div class="pk-match-players">
            <div class="pk-match-player">
              <img :src="playerInfo.avatar || '../../static/images/default-avatar.png'" alt="">
              <strong>{{ playerInfo.nickname }}</strong>
            </div>
            <div class="pk-match-vs"><img src="../../static/images/vs.png" alt=""></div>
            <div class="pk-match-player">
              <img :src="opponentInfo.avatar || '../../static/images/wait-avatar.png'" alt="">
              <strong>{{ formatOpponentNickname(opponentInfo.nickname) }}</strong>
            </div>
          </div>
          <p>{{$t('Waiting')}}: {{ waitTime }}s</p>
        </div>
      </div>
    </section>

    <!-- 对战面板 -->
    <section class="pk-battle-screen" v-if="gameState === 'playing'">
      <img class="pk-page-title pk-battle-title" src="../../static/images/pk/team_mode_title.png" :alt="$t('game3T')">

      <!-- 新增倒计时特效 -->
      <div v-if="countdownVisible" class="countdown-overlay">
        <img class="countdown-number" :key="countdownNumber" :src="'static/images/livequiz/ready/' + countdownNumber + '.png'" :alt="countdownNumber">
      </div>

      <div class="pk-score-board">
        <div class="pk-score-player pk-score-player--you">
          <strong class="pk-score-name">{{ playerInfo.nickname }}</strong>
          <div class="pk-score-track" :style="{ '--score-rate': (Math.max(0, Math.min(1, Number(scores.your_score_rate) || 0)) * 100) + '%' }">
            <i></i>
            <span class="pk-score-value"><em>{{ scores.player }}</em><b>{{$t('LiveQuizPts')}}</b></span>
          </div>
          <img :src="playerInfo.avatar || '../../static/images/default-avatar.png'" alt="">
        </div>
        <div class="pk-score-player pk-score-player--opponent">
          <strong class="pk-score-name">{{ formatOpponentNickname(opponentInfo.nickname) }}</strong>
          <div class="pk-score-track" :style="{ '--score-rate': (Math.max(0, Math.min(1, Number(scores.opponent_score_rate) || 0)) * 100) + '%' }">
            <i></i>
            <span class="pk-score-value"><em>{{ scores.opponent }}</em><b>{{$t('LiveQuizPts')}}</b></span>
          </div>
          <img :src="opponentInfo.avatar || '../../static/images/default-avatar.png'" alt="">
        </div>
      </div>
      <div class="pk-question-card" v-if="!countdownVisible">
        <div class="pk-question-timer" :style="{ '--timer-progress': (totalTime ? Math.max(0, (totalTime - countdown) / totalTime * 360) : 0) + 'deg' }">
          <strong>{{ countdown }}</strong>
        </div>
        <div class="pk-question-number" v-if="currentQuestionIndex">{{$t('Question')}} {{ currentQuestionIndex }}</div>
        <h2 class="pk-question-title">{{ currentQuestion }}</h2>
        <div class="pk-answer-list">
            <button
              v-for="(option, key) in currentOptions"
              :key="key"
              class="pk-answer-option"
              :class="{
                'correct': answerRevealed && key === correctAnswer,
                'wrong': answerRevealed && selectedAnswer === key && key !== correctAnswer
              }"
              :disabled="answerRevealed || isAnswerSubmitted"
              @click="selectAnswer(key)"
            >
              <span class="pk-answer-text">{{ option }}</span>
              <img v-if="answerRevealed && key === correctAnswer" src="../../static/images/Correct.png" alt="">
              <img v-else-if="answerRevealed && selectedAnswer === key && key !== correctAnswer" src="../../static/images/Wrong.png" alt="">
            </button>
        </div>
      </div>
    </section>

    <div class="pk-result-popup" v-if="gameState === 'ended'">
      <div class="pk-result-popup-mask"></div>
      <section class="pk-result-popup-dialog" role="dialog" aria-modal="true" :aria-label="$t('GameOver')">
        <div class="pk-result-popup-header">
          <img src="../../static/images/win_lose/pop_up_header.png" alt="">
          <h2 v-if="gameResult === 'win'">{{ $t('GameWinTitle') }}</h2>
          <h2 v-else-if="gameResult === 'lose'">{{ $t('GameLoseTitle') }}</h2>
          <h2 v-else>{{ $t('GameDrawTitle') }}</h2>
        </div>
        <div class="pk-result-popup-card">
          <img class="pk-result-popup-card-bg" src="../../static/images/win_lose/pop_up_bg.png" alt="">
          <div class="pk-result-popup-content">
            <p class="pk-result-message" v-if="gameResult === 'win'"><strong>{{ $t('GameWinLead') }}</strong> {{ $t('GameWinMessage') }}</p>
            <p class="pk-result-message" v-else-if="gameResult === 'lose'"><strong>{{ $t('GameLoseLead') }}</strong> {{ $t('GameLoseMessage') }}</p>
            <p class="pk-result-message" v-else>{{ $t('GameDrawMessage') }}</p>
            <img v-if="gameResult === 'win'" class="pk-result-hero" src="../../static/images/win_lose/win.png" alt="">
            <img v-else-if="gameResult === 'lose'" class="pk-result-hero" src="../../static/images/win_lose/lose.png" alt="">
            <img v-else class="pk-result-hero" src="../../static/images/win_lose/quiz_over.png" alt="">
            <div class="pk-result-scores">
              <img src="../../static/images/win_lose/score_bg.png" alt="">
              <div class="pk-result-score">
                <span>{{ $t('YourScore') }}</span>
                <div class="pk-result-score-number"><img src="../../static/images/home/pts.png" alt=""><strong>{{ resultScores.player }}</strong></div>
              </div>
              <div class="pk-result-score">
                <span>{{ $t('OpponentScore') }}</span>
                <div class="pk-result-score-number"><img src="../../static/images/home/pts.png" alt=""><strong>{{ resultScores.opponent }}</strong></div>
              </div>
            </div>
            <div class="pk-result-actions">
              <button type="button" @click="$router.push({path:'/quizCenter'})"><img src="../../static/images/win_lose/back.png" alt=""><span>{{ $t('Back') }}</span></button>
              <button type="button" @click="restartGame"><img src="../../static/images/win_lose/play_again.png" alt=""><span>{{ $t('PlayAgain') }}</span></button>
            </div>
          </div>
        </div>
        <button class="pk-result-close" type="button" :aria-label="$t('Back')" @click="$router.push({path:'/quizCenter'})"><img src="../../static/images/buy_more/close.png" alt=""></button>
      </section>
    </div>

    <div class="pk-buy-popup" v-if="showBuyMorePopup">
      <div class="pk-buy-popup-mask" @click="cancelOtpDialog"></div>
      <section class="pk-buy-popup-dialog" role="dialog" aria-modal="true" :aria-label="$t('BuyChances')">
        <div class="pk-buy-popup-header">
          <img src="../../static/images/buy_more/pop_up_header.png" alt="">
          <h2>{{ $t('BuyChances') }}</h2>
        </div>
        <div class="pk-buy-popup-card">
          <img class="pk-buy-popup-card-bg" src="../../static/images/buy_more/buy_chance_pop_up_bg.png" alt="">
          <div class="pk-buy-popup-content">
            <p>
              <span>{{ $t('BuyMoreChancesCopy') }}</span>
              <span>{{ $t('BuyMoreChancesWin') }} <strong>{{ $t('BuyMoreChancesHighlight') }}</strong></span>
            </p>
            <img class="pk-buy-popup-hero" src="../../static/images/buy_more/buy_chance_photo.png" alt="">
            <button class="pk-buy-popup-option" type="button" @click="getSubmit">
              <img class="pk-buy-popup-option-bg" src="../../static/images/buy_more/chance_bg.png" alt="">
              <img src="../../static/images/buy_more/one_time_purchase.png" :alt="$t('one_time_purchase')">
              <span>{{ $t('one_time_purchase') }}</span>
            </button>
            <div class="pk-buy-popup-balance">
              <span>{{ $t('CurrentChances') }}</span>
              <img src="../../static/images/home/chance.png" alt="">
              <strong>{{ info.score || 0 }}</strong>
            </div>
          </div>
        </div>
        <button class="pk-buy-popup-close" type="button" :aria-label="$t('Later')" @click="cancelOtpDialog">
          <img src="../../static/images/buy_more/close.png" alt="">
        </button>
      </section>
    </div>



  </div>
</template>

<script>
import Header from '../components/HeaderOne'
import Dialog from '../components/dialog'
import Clipboard from 'clipboard';
import AudioService from '@/services/AudioService'
export default {
    components:{
		Header,Dialog
    },
  name: 'FriendBattle',
  data() {
    return {
      info:{},
      ws: null,
      connectionStatus: 'Not connected',
      gameState: 'connecting', // connecting, matching, playing, ended
      playerInfo: {
        user_id: null,
        nickname: '',
        avatar: '',
        level: null
      },
      opponentInfo: {
        user_id: null,
        nickname: '',
        avatar: '',
        level: null
      },
      roomId: null,
      room_id_div:true,
      roomInput: '',
      waitTime: 0,
      matchTimer: null,
      currentQuestionIndex: 0,
      totalQuestions: 0,
      currentQuestion: '',
      currentOptions: {},
      correctAnswer: null,
      selectedAnswer: null,
      answerRevealed: false,
      isAnswerSubmitted: false,
      scores: {
        player: 0,
        opponent: 0
      },
      gameOverResults: [],
      countdown: 0,
      timerInterval: null,
      showResultModal: false,
      modalMyScore: 0,
      modalOpponentScore: 0,
      resultClass: '',
      resultIcon: '🎉',
      resultTitle: '',
      resultTips: '',
      showRoomControl: false,
      totalTime: 10, // 总时间用于计算百分比
      isReStart:0,//是否是再次答题
      // 新增倒计时相关数据
      countdownVisible: false,
      countdownNumber: 3,
      //音效
      audioService: AudioService,
      isBgmPlaying: false,
      showBuyMorePopup: false
    }
  },
  computed: {
    timerProgress() {
      return (this.countdown / this.totalTime) * 100;
    },
    resultScores() {
      const ownId = String(this.playerInfo.user_id);
      const currentPlayer = this.gameOverResults.find(player => String(player.user_id) === ownId);
      const opponentPlayer = this.gameOverResults.find(player => String(player.user_id) !== ownId);
      return {
        player: Number((currentPlayer || {}).score) || 0,
        opponent: Number((opponentPlayer || {}).score) || 0
      };
    }
  },
  created() {
    this.getUserInfo();
    this.connect();
    this.resultTitle = this.$t('GameOver')
  },
  mounted(){
    this.audioService.init();
    this.startBackgroundMusic();
  },
  beforeDestroy() {
    this.disconnect();
    this.stopBackgroundMusic();
  },
  methods: {
    isCurrentPlayer(userId) {
      return String(userId) === String(this.playerInfo.user_id);
    },
    formatOpponentNickname(nickname) {
      const value = String(nickname || '');
      return /^\+?\d{7,15}$/.test(value)
        ? value.replace(/^(\+?\d{3})\d+(\d{2})$/, '$1****$2')
        : value;
    },
    copy(item){
        var clipboard = new Clipboard("#copycode");
        clipboard.on("success", (e) => {
          this.$utils.alertText(this.$t('CopySucceeded'),80);
          // 释放内存
          clipboard.destroy();
        });
        clipboard.on("error", (e) => {
          // 不支持复制
          //console.log("该浏览器不支持自动复制");
          // 释放内存
          clipboard.destroy();
        });
    },
    getUserInfo(){
      let that =this;
      that.$api.get('/api/user/info',null,r =>{
        that.$parent.returnCode(r,function(){
          that.info = r.data
        });
      })
    },
    connect() {
      this.ws = new WebSocket('wss://battle.goquizgo.com/ws');

      this.ws.onopen = () => {
        console.log('WebSocket connected');
        this.connectionStatus = 'WebSocket connected';
        this.login();
      };

      this.ws.onmessage = (e) => {
        const data = JSON.parse(e.data);
        this.handleMessage(data);
      };

      this.ws.onerror = (error) => {
        console.error('WebSocket error:', error);
        this.connectionStatus = 'WebSocket error';
      };

      this.ws.onclose = () => {
        console.log('WebSocket closed');
        this.connectionStatus = 'WebSocket closed';
      };
    },
    login(){
      this.ws.send(JSON.stringify({
        match_type: 'pk',
        action: 'login',
        mobile: localStorage.getItem('mobile')
      }));
    },
    disconnect() {
      if (this.ws) {
        this.ws.close();
      }
      this.clearTimers();
    },
    clearTimers() {
      if (this.matchTimer) {
        clearInterval(this.matchTimer);
        this.matchTimer = null;
      }
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
    },
    handleMessage(data) {
      if (data.match_type !== 'pk'){
        return;
      }
      switch(data.action) {
        case 'login_success':
          this.handleLoginSuccess(data);
          break;
        case 'chance_error':
          this.handleChanceError(data);
          break;
        case 'create_success':
          this.handleRoomCreated(data);
          break;
        case 'enter_room':
          this.startGame(data);
          break;
        case 'match_waiting':
          this.showMatchPanel(data);
          break;
        case 'new_question':
          this.showQuestion(data);
          break;
        case 'answer_result':
          this.handleAnswerResult(data);
          break;
        case 'game_over':
          this.endGame(data);
          break;
        case 'join_error':
          this.joinError(data);
          break;
        case 'timeout':
          this.playSound('basic.wrong')
          break;
        //断开重连
        case 'reconnect_room':
          this.handleReconnect(data);
          break;
        case 'error':
          console.log(data.message);
          break;
      }
    },
    createRoom() {
      this.ws.send(JSON.stringify({
        match_type: 'pk',
        action: 'create_room'
      }));
    },
    joinRoom() {
      if (this.roomInput) {
        this.ws.send(JSON.stringify({
          match_type: 'pk',
          action: 'join_room',
          room_id: this.roomInput
        }));
      } else {
        this.$utils.alertText(this.$t('enterRoomID'),80);
      }
    },
    showMatchPanel(data) {
      this.roomId = data.data.room_id;
      this.showRoomControl = false;
      this.gameState = 'matching';
      this.waitTime = 0;
      this.matchTimer = setInterval(() => {
        this.waitTime++;
      }, 1000);
    },
    handleLoginSuccess(data) {
      this.showRoomControl = true;
      this.playerInfo = {
        user_id: data.data.user_id,
        nickname: data.data.nickname,
        avatar: data.data.avatar,
        level: data.data.level
      };
    },
    handleRoomCreated(data) {
      this.roomId = data.data.room_id;
      this.gameState = 'matching';
      this.showRoomControl = false;
    },
    startGame(data) {
      this.clearTimers();
      this.clearQuestion();

      this.timeTotal = 3;
      this.timeLeft = 3;
      this.startTimer();

      this.startCountDown();

      this.showRoomControl = false;
      this.gameState = 'playing';
      this.roomId = data.room_id;

      // 确定玩家和对手
      const player1 = data.opponent.player1;
      const player2 = data.opponent.player2;

      if (this.isCurrentPlayer(player1.user_id)) {
        this.opponentInfo = {
          user_id: player2.user_id,
          nickname: player2.nickname,
          avatar: player2.avatar,
          level: player2.level
        };
      } else {
        this.opponentInfo = {
          user_id: player1.user_id,
          nickname: player1.nickname,
          avatar: player1.avatar,
          level: player1.level
        };
      }

      // 重置分数
      this.scores = { player: 0, opponent: 0 };
    },
    showQuestion(data) {
      this.currentQuestionIndex = data.question_no;
      this.totalQuestions = data.question_count;
      this.currentQuestion = data.question;
      this.currentOptions = data.options;
      this.answerRevealed = false;
      this.isAnswerSubmitted = false;
      this.selectedAnswer = null;
      this.totalTime = data.timeout || 10;
      this.startTimer(this.totalTime);
    },
    startTimer(seconds) {
      seconds = Math.max(1, parseInt(seconds) || 10);

      if (this.timerInterval) {
        clearInterval(this.timerInterval);
      }

      let remaining = seconds;
      this.countdown = remaining;

      this.timerInterval = setInterval(() => {
        remaining = Math.max(0, remaining - 1);
        this.countdown = remaining;

        if (remaining <= 0) {
          clearInterval(this.timerInterval);
          this.disableOptions();
        }
      }, 1000);
    },
    selectAnswer(answerKey) {
      this.startBackgroundMusic()
      this.selectedAnswer = answerKey;
      this.isAnswerSubmitted = true;

      this.ws.send(JSON.stringify({
        match_type: 'pk',
        action: 'submit_answer',
        room_id: this.roomId,
        question_no: this.currentQuestionIndex,
        answer: answerKey
      }));
    },
    handleAnswerResult(data) {
      if (this.gameState !== 'playing') {
        return;
      }
      if (this.isCurrentPlayer(data.user_id)) {
        this.scores.player = data.your_score;
        this.scores.opponent = data.opponent_score;
        this.scores.your_score_rate = data.your_score_rate;
        this.scores.opponent_score_rate = data.opponent_score_rate;
        this.correctAnswer = data.correct_answer;
        this.answerRevealed = true;
        if (data.is_correct){
          //答对
          this.playSound('basic.correct')
        }else {
          //答错
          this.playSound('basic.wrong')
        }
      } else {
        this.scores.opponent = data.your_score;
      }
    },
    disableOptions() {
      this.isAnswerSubmitted = true;
    },
    endGame(data) {
      this.clearTimers();
      this.clearQuestion();
      this.gameState = 'ended';
      this.showResult(data);
    },
    showResult(data) {
      this.gameOverResults = Array.isArray(data.results) ? data.results : [];
      const results = this.gameOverResults;
      if (!results.length) {
        this.gameResult = null;
        return;
      }
      const maxScore = Math.max(...results.map(player => player.score));
      const winners = results.filter(player => player.score === maxScore);
      const currentPlayer = results.find(player => this.isCurrentPlayer(player.user_id));
      const opponentPlayer = results.find(player => !this.isCurrentPlayer(player.user_id));

      if (!currentPlayer || !opponentPlayer) {
        this.gameResult = null;
      } else if (currentPlayer.score === maxScore) {
        this.gameResult = winners.length > 1 ? 'draw' : 'win';
        this.playSound('sfx.win')
      } else {
        this.gameResult = 'lose';
        this.playMusic();
        this.playSound('sfx.lose')
      }
    },
    closeResultModal() {
      this.showResultModal = false;
      this.roomInput = '';
      this.resetToLobby();
    },
    restartGame() {
      this.clearTimers();
      this.clearQuestion();
      this.isReStart = 1;
      this.showResultModal = false;
      this.currentQuestionIndex = 0;
      this.room_id_div = false;
      this.scores = { player: 0, opponent: 0 };
      this.ws.send(JSON.stringify({
        match_type: 'pk',
        action: 'one_more',
        room_id: this.roomId
      }));
      this.gameState = 'playing';
    },
    resetToLobby() {
      this.gameState = 'connecting';
      this.showRoomControl = true;
      this.roomId = null;
    },
    joinError(data) {
      this.$utils.alertText(data.msg,80);
    },
    clearQuestion(){
      this.currentQuestionIndex = 0;
      this.totalQuestions = 0;
      this.currentQuestion = "";
      this.currentOptions = {};
      this.timeTotal = 10;
      this.timeLeft = 0;
      this.answerRevealed = false;
      this.isAnswerSubmitted = false;
      this.selectedAnswer = null;
    },
    //恢复链接
    handleReconnect(data){
      this.showRoomControl = false;
      this.roomId = data.room_id;
      //恢复玩家信息
      this.playerInfo = {
        user_id: data.playerInfo.user_id,
        nickname: data.playerInfo.nickname,
        avatar: data.playerInfo.avatar,
        level: data.playerInfo.level
      };
      //恢复玩家和对手
      const player1 = data.opponent.player1;
      const player2 = data.opponent.player2;
      if (this.isCurrentPlayer(player1.user_id)) {
        this.opponentInfo = {
          user_id: player2.user_id,
          nickname: player2.nickname,
          avatar: player2.avatar,
          level: player2.level
        };
      } else {
        this.opponentInfo = {
          user_id: player1.user_id,
          nickname: player1.nickname,
          avatar: player1.avatar,
          level: player1.level
        };
      }
      //恢复分数信息
      this.scores.player = data.opponent_score.your_score;
      this.scores.opponent = data.opponent_score.opponent_score;
      this.scores.your_score_rate = data.opponent_score.your_score_rate;
      this.scores.opponent_score_rate = data.opponent_score.opponent_score_rate;
      //恢复题目
      this.currentQuestionIndex = data.question_data.question_no;
      this.totalQuestions = data.question_data.question_count;
      this.currentQuestion = data.question_data.question;
      this.currentOptions = data.question_data.options;
      this.timeTotal = data.question_data.timeout || 10;
      this.timeLeft = this.timeTotal;
      this.startTimer();
      //恢复答题结果
      this.isAnswerSubmitted = data.current_question_result.isAnswerSubmitted;
      this.selectedAnswer = data.current_question_result.user_answer;
      if (data.current_question_result.user_answer){
        this.correctAnswer = data.current_question_result.correctAnswer;
        this.answerRevealed = true;
      }
      this.gameState = 'playing';
    },
    handleChanceError(data){
      let that =this;
      that.gameState = 'connecting'
      that.showBuyMorePopup = true;
      that.getUserInfo();
    },
    cancelOtpDialog(){
      this.showBuyMorePopup = false;
      this.$router.push({path:'/quizCenter'});
    },
    getSubmit(){
      let that = this
      that.$parent.loadModal(true);
      that.$api.post('/api/index/buy',null,r =>{
        that.$parent.returnCode(r,function(){
          that.$parent.loadModal(false);
          if (r.code == 1){
            that.showBuyMorePopup = false;
            that.getUserInfo();
            that.$utils.alertText(r.msg,80, 800);
            if (that.isReStart){
              that.restartGame();
            }
          }else{
            that.$utils.alertText(r.msg,80, 3000);
          }
        });
      })
    },
    startCountDown(){
      // 启动3秒倒计时特效
      this.countdownVisible = true;
      this.countdownNumber = 3;
      this.playSound('sfx.countdown')
      const countdownInterval = setInterval(() => {
        this.countdownNumber -= 1;
        if (this.countdownNumber <= 0) {
          clearInterval(countdownInterval);
          this.countdownVisible = false;
        }
      }, 1000);
    },
    playSound(soundName) {
      this.audioService.play(soundName)
        .then(() => console.log(`${soundName} 播放成功`))
        .catch(e => console.error(`${soundName} 播放失败:`, e));
    },
    startBackgroundMusic() {
      // 如果正在播放，则不再重复播放
      if (this.isBgmPlaying) {
        console.log('背景音乐已在播放中');
        return;
      }
      this.audioService.play('bgm.main', { loop: true })
        .then(() => {
          this.isBgmPlaying = true;
          console.log('背景音乐开始播放');
        })
        .catch(e => {
          console.error('背景音乐播放失败:', e);
          this.isBgmPlaying = false;
        });
    },
    stopBackgroundMusic() {
      this.audioService.stopBackground();
      console.log('背景音乐已停止');
    }
  }
}
</script>

<style scoped>
.countdown-overlay { position:fixed; top:0; left:0; width:100%; height:100%; background:rgba(5,0,25,.28); display:flex; justify-content:center; align-items:center; z-index:9999; pointer-events:none; }
.countdown-number { display:block; width:min(64vw,430px); height:min(48vh,430px); object-fit:contain; filter:drop-shadow(0 16px 35px rgba(255,84,180,.22)); animation:countdownPop .8s cubic-bezier(.25,.46,.45,.94) both; }

.pk-redesign-page { position:relative; min-height:100vh; box-sizing:border-box; isolation:isolate; padding:46px 28px 96px; overflow-x:hidden; color:#fff; background:#06021d url('../../static/images/livequiz/main_bg.jpg') center top/100% 100% no-repeat; font-family:Arial,Atom-sans,sans-serif; }
.pk-redesign-page::before { position:absolute; z-index:0; inset:0; content:''; background:rgba(7,0,26,.2); pointer-events:none; }
.pk-legacy-header { display:none; }
.pk-redesign-header { position:absolute; z-index:20; top:46px; right:0; left:0; width:calc(100% - 56px); max-width:650px; margin:0 auto; }
.pk-redesign-back { display:flex; width:72px; height:72px; align-items:center; justify-content:center; padding:0; border:0; background:transparent; cursor:pointer; }
.pk-redesign-back img { display:block; width:100%; height:100%; object-fit:contain; }

.pk-room-screen,.pk-matching-screen,.pk-battle-screen { position:relative; z-index:1; width:100%; max-width:650px; margin:0 auto; }
.pk-page-title { display:block; width:min(78%,520px); margin:0 auto 58px; }
.pk-room-panel,.pk-matching-panel { position:relative; width:100%; aspect-ratio:1046 / 1420; overflow:hidden; }
.pk-room-panel-bg,.pk-matching-panel-bg { position:absolute; inset:0; display:block; width:100%; height:100%; }
.pk-room-panel-content,.pk-matching-panel-content { position:absolute; inset:0; display:flex; box-sizing:border-box; flex-direction:column; align-items:center; padding:8% 7.5% 8%; text-align:center; }
.pk-room-description { width:88%; min-height:2.4em; margin:0 0 3%; color:#fff; font-size:clamp(16px,4.2vw,28px); font-weight:500; line-height:1.17; text-align:center; }
.pk-room-hero { display:block; width:100%; margin:0 0 4%; border-radius:26px; object-fit:contain; }
.pk-room-matchup { display:grid; width:100%; grid-template-columns:1fr .44fr 1fr; align-items:center; margin:0 0 4%; padding:4% 6%; box-sizing:border-box; border-radius:28px; background:#26233f; }
.pk-room-player,.pk-room-friend { display:flex; min-width:0; align-items:center; flex-direction:column; gap:8px; color:#fff; font-size:clamp(14px,3.7vw,25px); font-weight:500; line-height:1.05; }
.pk-room-player img,.pk-room-friend img { display:block; width:clamp(72px,20vw,124px); height:clamp(72px,20vw,124px); box-sizing:border-box; border:4px solid #fff; border-radius:50%; object-fit:cover; background:#10052e; }
.pk-room-player strong,.pk-room-friend strong { width:100%; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
.pk-room-vs { display:block; width:100%; max-width:95px; margin:0 auto; object-fit:contain; }
.pk-room-join { display:grid; width:100%; grid-template-columns:minmax(0,1fr) 34%; gap:2%; align-items:center; margin:0; }
.pk-room-join input { width:100%; height:auto; aspect-ratio:893 / 142; padding:0 5%; box-sizing:border-box; border:2px solid rgba(255,255,255,.68); border-radius:999px; appearance:textfield; color:#fff; background:#10082d url('../../static/images/pk/room_id_bg.png') center/100% 100% no-repeat; font:italic 900 clamp(22px,7vw,48px)/1 Arial,Atom-sans,sans-serif; letter-spacing:.16em; text-align:center; outline:0; }
.pk-room-join input::-webkit-inner-spin-button,.pk-room-join input::-webkit-outer-spin-button { margin:0; -webkit-appearance:none; }
.pk-room-join input::placeholder { color:rgba(255,255,255,.7); font-size:.48em; font-style:normal; font-weight:500; letter-spacing:0; }
.pk-room-join button { position:relative; display:block; width:100%; padding:0; border:0; background:transparent; cursor:pointer; font:inherit; }
.pk-room-join button img { display:block; width:100%; }
.pk-room-join button span { position:absolute; top:51%; right:4%; left:4%; transform:translateY(-50%); color:#fff; font-size:clamp(13px,3.5vw,24px); font-weight:900; line-height:1; text-shadow:0 3px 3px rgba(75,0,43,.75); text-transform:uppercase; white-space:nowrap; }
.pk-room-create { display:flex; width:62%; min-height:0; aspect-ratio:754 / 167; align-items:center; justify-content:center; margin:5% 0 0; padding:0; border:0; color:#fff; background:transparent url('../../static/images/livequiz/btn_bg.png') center/100% 100% no-repeat; cursor:pointer; font:inherit; font-size:clamp(18px,5.1vw,35px); font-weight:900; line-height:1; text-shadow:0 3px 5px rgba(81,0,42,.65); }

.pk-matching-panel-content h2 { margin:0; color:#fff; font-size:clamp(22px,6vw,40px); font-weight:800; line-height:1; }
.pk-room-code { display:flex; align-items:center; justify-content:center; gap:8px; margin:7% 0 3%; padding:0; border:0; color:#ffeb75; background:transparent; cursor:pointer; font:inherit; font-size:clamp(17px,4.5vw,31px); font-weight:800; line-height:1; }
.pk-room-code img { width:clamp(24px,7vw,50px); height:clamp(24px,7vw,50px); object-fit:contain; }
.pk-match-players { display:flex; width:100%; align-items:center; justify-content:space-between; margin:7% 0 9%; }
.pk-match-player { display:flex; width:31%; align-items:center; flex-direction:column; gap:10px; color:#fff; font-size:clamp(13px,3.5vw,23px); line-height:1; }
.pk-match-player > img { display:block; width:100%; aspect-ratio:1; box-sizing:border-box; border:3px solid rgba(255,255,255,.95); border-radius:50%; object-fit:cover; background:#fff; }
.pk-match-vs { display:flex; width:25%; aspect-ratio:1; align-items:center; justify-content:center; border-radius:50%; background:rgba(106,72,255,.72); }
.pk-match-vs img { display:block; width:60%; height:60%; object-fit:contain; }
.pk-matching-panel-content p { margin:3px 0; color:#fff; font-size:clamp(15px,4vw,27px); font-weight:600; line-height:1.25; }

.pk-battle-title { margin-bottom:46px; }
.pk-score-board { display:grid; grid-template-columns:minmax(0,1fr) minmax(0,1fr); gap:32px; align-items:end; margin:0 -4px 76px; }
.pk-score-player { position:relative; display:block; min-height:116px; overflow:visible; color:#fff; background:transparent; }
.pk-score-name { position:absolute; z-index:3; top:0; max-width:58%; overflow:hidden; font-size:clamp(16px,4.5vw,31px); font-weight:500; line-height:1; text-overflow:ellipsis; white-space:nowrap; }
.pk-score-track { position:absolute; right:0; bottom:0; left:0; display:flex; min-height:66px; align-items:center; overflow:hidden; box-sizing:border-box; border:2px solid rgba(255,255,255,.9); border-radius:999px; background:rgba(7,2,36,.82); }
.pk-score-track > i { position:absolute; top:0; bottom:0; left:0; z-index:0; width:var(--score-rate); background:#08d91d; }
.pk-score-value { position:relative; z-index:1; display:flex; align-items:baseline; gap:4px; color:#fff; }
.pk-score-value em { font-size:clamp(28px,7vw,48px); font-style:italic; font-weight:900; line-height:.9; }
.pk-score-value b { font-size:clamp(14px,3.5vw,24px); font-weight:800; line-height:1; }
.pk-score-player > img { position:absolute; bottom:0; z-index:2; display:block; width:110px; height:110px; border:4px solid #fff; border-radius:50%; object-fit:cover; background:#16034d; }
.pk-score-player--you { text-align:left; }
.pk-score-player--you .pk-score-name { left:42%; }
.pk-score-player--you .pk-score-track { left:35px; padding-left:35%; }
.pk-score-player--you > img { left:0; }
.pk-score-player--opponent { text-align:right; }
.pk-score-player--opponent .pk-score-name { right:42%; }
.pk-score-player--opponent .pk-score-track { right:35px; justify-content:flex-end; padding-right:35%; }
.pk-score-player--opponent > img { right:0; }
.pk-score-player--opponent .pk-score-track > i { right:0; left:auto; }

.pk-question-card { position:relative; display:flex; width:100%; min-height:780px; box-sizing:border-box; flex-direction:column; padding:17% 7.2% 11.5%; background:transparent url('../../static/images/livequiz/start/quiz_bg.png') center/100% 100% no-repeat; color:#171722; }
.pk-question-timer { --timer-progress:0deg; position:absolute; z-index:2; top:-66px; left:50%; display:flex; width:148px; height:148px; align-items:center; justify-content:center; border-radius:50%; background:conic-gradient(#f3164c 0deg,#f3164c var(--timer-progress),#4378da var(--timer-progress),#4378da 360deg); box-shadow:0 4px 12px rgba(13,24,88,.28); transform:translateX(-50%); }
.pk-question-timer::after { position:absolute; inset:8px; border-radius:50%; content:''; background:#f2f1f4; }
.pk-question-timer strong { position:relative; z-index:1; display:flex; width:100%; height:100%; align-items:center; justify-content:center; margin:0; padding:0; color:#16151f; font-size:clamp(42px,13vw,78px); font-style:normal; font-weight:900; line-height:1; text-align:center; }
.pk-question-number { display:flex; width:clamp(150px,40%,205px); aspect-ratio:267 / 56; align-items:center; justify-content:center; align-self:center; margin:0 auto 24px; color:#25202c; background:transparent url('../../static/images/livequiz/start/question_bg.png') center/contain no-repeat; font-size:clamp(16px,4.2vw,27px); line-height:1; text-align:center; }
.pk-question-title { display:flex; min-height:130px; align-items:center; justify-content:center; margin:0 3% 27px; color:#171722; font-size:clamp(18px,4.7vw,31px); font-weight:700; line-height:1.3; text-align:center; }
.pk-answer-list { display:flex; flex-direction:column; gap:20px; }
.pk-answer-option { position:relative; display:flex; width:100%; min-height:clamp(76px,18vw,110px); align-items:center; padding:10px 7%; overflow:hidden; box-sizing:border-box; border:0; border-radius:999px; color:#171722; background:transparent url('../../static/images/livequiz/start/ans_bg.png') center/100% 100% no-repeat; cursor:pointer; font:inherit; font-size:clamp(18px,4.8vw,31px); font-weight:700; line-height:1.35; text-align:left; }
.pk-answer-option:disabled { cursor:default; }
.pk-answer-option.correct { color:#171722; background:transparent url('../../static/images/livequiz/start/my_correct_ans.png') center/100% 100% no-repeat; }
.pk-answer-option.wrong { color:#171722; background:transparent url('../../static/images/livequiz/start/my_wrong_ans.png') center/100% 100% no-repeat; }
.pk-answer-text { display:flex; min-width:0; align-self:stretch; align-items:center; padding-right:48px; overflow:visible; white-space:normal; }
.pk-answer-option > img { position:absolute; top:50%; right:5%; width:42px; height:42px; object-fit:contain; transform:translateY(-50%); }
.pk-result-popup { position:fixed; z-index:140; inset:0; }
.pk-result-popup-mask { position:absolute; inset:0; }
.pk-result-popup-dialog { position:absolute; top:11.5vh; left:50%; width:min(calc(100% - 28px),750px); transform:translateX(-50%); }
.pk-result-popup-header { position:relative; z-index:2; }
.pk-result-popup-header > img { display:block; width:100%; }
.pk-result-popup-header h2 { position:absolute; top:68%; right:10%; left:10%; margin:0; transform:translateY(-50%); color:#fff; font-size:clamp(32px,9.5vw,67px); font-weight:900; line-height:1; letter-spacing:-.05em; text-align:center; text-shadow:0 3px 2px #942006,0 0 8px rgba(255,190,35,.85); -webkit-text-stroke:1px #9d2a06; text-transform:uppercase; white-space:nowrap; }
.pk-result-popup-card { position:relative; margin-top:-5.5%; }
.pk-result-popup-card-bg { display:block; width:100%; }
.pk-result-popup-content { position:absolute; inset:0; display:flex; box-sizing:border-box; flex-direction:column; align-items:center; padding:13% 7.5% 8%; }
.pk-result-message { min-height:2.2em; margin:0; color:#fff; font-size:clamp(15px,4.1vw,30px); font-weight:500; line-height:1.12; text-align:center; }
.pk-result-message strong { color:#ffde00; font-weight:800; }
.pk-result-hero { display:block; width:100%; max-width:620px; min-height:0; flex:1 1 auto; margin:1% auto 0; object-fit:contain; transform:scale(1.15); transform-origin:center bottom; }
.pk-result-scores { position:relative; display:grid; width:100%; grid-template-columns:1fr 1fr; margin-top:1%; aspect-ratio:887 / 203; align-items:center; }
.pk-result-scores > img { position:absolute; inset:0; width:100%; height:100%; object-fit:fill; }
.pk-result-score { position:relative; z-index:1; display:flex; min-width:0; flex-direction:column; align-items:center; justify-content:center; color:#fff; text-align:center; }
.pk-result-score + .pk-result-score { border-left:1px solid rgba(255,255,255,.65); }
.pk-result-score span { font-size:clamp(13px,3.5vw,25px); font-weight:500; line-height:1.1; white-space:nowrap; }
.pk-result-score-number { display:flex; align-items:center; justify-content:center; gap:5px; margin-top:3%; }
.pk-result-score-number img { width:clamp(18px,5vw,36px); height:clamp(18px,5vw,36px); object-fit:contain; }
.pk-result-score strong { color:#ffcb00; font-size:clamp(25px,7.5vw,54px); font-style:italic; font-weight:900; line-height:.88; text-shadow:0 2px 1px rgba(113,50,0,.45); }
.pk-result-actions { display:flex; width:100%; align-items:center; justify-content:space-between; gap:4%; margin-top:5%; }
.pk-result-actions button { position:relative; display:block; width:48%; padding:0; border:0; background:transparent; cursor:pointer; font:inherit; }
.pk-result-actions img { display:block; width:100%; }
.pk-result-actions span { position:absolute; top:51%; right:6%; left:6%; transform:translateY(-50%); color:#fff; font-size:clamp(17px,4.7vw,34px); font-weight:900; line-height:1; text-align:center; text-shadow:0 3px 2px rgba(4,3,28,.8); text-transform:uppercase; white-space:nowrap; }
.pk-result-close { display:block; width:clamp(42px,13vw,96px); margin:3% auto 0; padding:0; border:0; background:transparent; cursor:pointer; }
.pk-result-close img { display:block; width:100%; }

.pk-buy-popup { position:fixed; z-index:120; inset:0; }
.pk-buy-popup-mask { position:absolute; inset:0; }
.pk-buy-popup-dialog { position:absolute; top:12.2vh; left:50%; width:min(calc(100% - 28px),750px); transform:translateX(-50%); }
.pk-buy-popup-header { position:relative; z-index:2; }
.pk-buy-popup-header > img { display:block; width:100%; }
.pk-buy-popup-header h2 { position:absolute; top:68%; right:10%; left:10%; margin:0; transform:translateY(-50%); color:#fff; font-size:clamp(25px,6.6vw,48px); font-weight:900; line-height:1; letter-spacing:-.035em; text-align:center; text-shadow:0 3px 2px #942006,0 0 8px rgba(255,190,35,.85); -webkit-text-stroke:1px #9d2a06; text-transform:uppercase; white-space:nowrap; }
.pk-buy-popup-card { position:relative; margin-top:-5.5%; }
.pk-buy-popup-card-bg { display:block; width:100%; }
.pk-buy-popup-content { position:absolute; inset:0; display:flex; align-items:center; box-sizing:border-box; flex-direction:column; padding:12% 8% 7%; }
.pk-buy-popup-content > p { width:90%; margin:0; color:#fff; font-size:clamp(15px,4vw,30px); font-weight:500; line-height:1.08; text-align:center; }
.pk-buy-popup-content > p span { display:block; }
.pk-buy-popup-content > p strong { color:#ffde00; font-weight:800; }
.pk-buy-popup-hero { display:block; width:72%; object-fit:contain; }
.pk-buy-popup-option { position:relative; width:38%; min-width:132px; overflow:hidden; border:0; border-radius:15px; padding:3% 2% 6%; background:#24213e; color:#fff; cursor:pointer; font:inherit; }
.pk-buy-popup-option::before { position:absolute; inset:0; content:''; border:1px solid rgba(255,255,255,.05); border-radius:inherit; background:linear-gradient(180deg,rgba(255,255,255,.08),transparent 55%); pointer-events:none; }
.pk-buy-popup-option > img:not(.pk-buy-popup-option-bg) { position:relative; z-index:1; display:block; width:56%; margin:0 auto; }
.pk-buy-popup-option-bg { position:absolute; inset:0; width:100%; height:100%; opacity:.52; object-fit:cover; }
.pk-buy-popup-option span { position:relative; z-index:1; display:block; margin-top:1%; color:#fff; font-size:clamp(13px,4vw,30px); font-weight:500; line-height:1.08; text-align:center; }
.pk-buy-popup-balance { display:flex; align-items:center; justify-content:center; gap:6px; margin-top:20px; color:#ffe878; font-size:clamp(14px,4.2vw,30px); font-weight:500; line-height:1; text-align:center; }
.pk-buy-popup-balance img { width:clamp(22px,6vw,44px); height:clamp(22px,6vw,44px); object-fit:contain; }
.pk-buy-popup-balance strong { color:#fff; font-size:1.05em; }
.pk-buy-popup-close { display:block; width:clamp(42px,13vw,96px); margin:5% auto 0; padding:0; border:0; background:transparent; cursor:pointer; }
.pk-buy-popup-close img { display:block; width:100%; }

@keyframes countdownPop {
  0% { transform:scale(0); opacity:0; }
  50% { transform:scale(1.2); opacity:1; }
  100% { transform:scale(1); opacity:0; }
}

@media (min-width:760px) {
  .pk-page-title { margin-bottom:72px; }
  .pk-score-player > img { width:108px; height:108px; }
  .pk-question-card { min-height:920px; }
}
</style>



// WEBPACK FOOTER //
// src/page/pk.vue